import { Page, Content } from '@backstage/core-components';
import {
  HomePageCompanyLogo,
  HomePageStarredEntities,
  HomePageToolkit,
  HomePageTopVisited,
  HomePageRecentlyVisited,  
  FeaturedDocsCard
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import {tools} from './shared';

import BidOneLogoFull from '../Root/BidoneLogoFull';
import { TechDocsHomePage } from '../techdocs/TechDocsHomePage';
import { TechDocsPicker, TechDocsReaderLayout } from '@backstage/plugin-techdocs';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';

const useStyles = makeStyles(theme => ({
  searchBarInput: {
    maxWidth: '60vw',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '50px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none',
  },
}));

export const HomePage = () => {
  const classes = useStyles();

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={2}>
            <HomePageCompanyLogo
              logo={<BidOneLogoFull />}
            />
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <HomePageSearchBar
                InputProps={{
                  classes: {
                    root: classes.searchBarInput,
                    notchedOutline: classes.searchBarOutline,
                  },
                }}
                placeholder="Search"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <HomePageTopVisited />
            </Grid>
            <Grid item xs={12} md={6}>
              <HomePageRecentlyVisited />
            </Grid>
            <Grid item xs={7}>
              <HomePageStarredEntities />
            </Grid>
            <Grid item xs={5}>
              {/* <HomePageToolkit tools={tools}  /> */}
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};